var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex flex-col gap-6 p-6",
      attrs: { id: "center-general-information" }
    },
    [
      _c(
        "div",
        { staticClass: "border bg-pure-white rounded-3xl border-slate-400" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center justify-between px-6 pt-6 pb-4 border-b border-slate-400"
            },
            [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _c("BlTextTitle4", {
                      attrs: { text: "General Information" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "Manage your clinic general settings and information."
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center gap-4" },
                [
                  _c("BlInputButton", {
                    attrs: { type: "outlined", label: "Cancel" },
                    on: {
                      clicked: function($event) {
                        return _vm.generateInputs(_vm.currentCenter)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: {
                      label: "Update",
                      loading: _vm.submitLoading,
                      disabled: _vm.isDisabledSubmit
                    },
                    on: { clicked: _vm.onUpdate }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "px-6 py-6" }, [
            _vm.pageLoading
              ? _c(
                  "div",
                  { staticClass: "grid w-full h-80 place-items-center" },
                  [_c("div", { staticClass: "blum-loader" })]
                )
              : _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-10 gap-4" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-900",
                      attrs: { text: "Logo" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid grid-cols-2 col-span-8" }, [
                      _c("input", {
                        attrs: {
                          type: "file",
                          name: "logo_url_input",
                          id: "logo_url_input",
                          hidden: ""
                        },
                        on: { change: _vm.onButtonUpload }
                      }),
                      _vm._v(" "),
                      !_vm.logoUrlInput
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col items-center justify-center gap-2 transition-all duration-300 border-2 border-dashed rounded-lg cursor-pointer h-25 border-slate-500 hover:border-solid hover:border-dark-purple-200",
                              class: { "bg-slate-200": _vm.dropActive },
                              attrs: { "data-active": _vm.dropActive },
                              on: {
                                click: _vm.openUpload,
                                dragenter: function($event) {
                                  $event.preventDefault()
                                  _vm.dropActive = true
                                },
                                dragover: function($event) {
                                  $event.preventDefault()
                                  _vm.dropActive = true
                                },
                                dragleave: function($event) {
                                  $event.preventDefault()
                                  _vm.dropActive = false
                                },
                                drop: function($event) {
                                  $event.preventDefault()
                                  return _vm.onDropUpload($event)
                                }
                              }
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "w-6 h-6",
                                attrs: { icon: "picture" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass:
                                  "transition-all duration-300 text-slate-600 hover:text-dark-purple-200",
                                attrs: {
                                  text:
                                    "Drop a picture or click to upload a logo"
                                }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "flex items-center" },
                            [
                              _c("img", {
                                staticClass: "h-25",
                                attrs: {
                                  src: _vm.logoUrlInput,
                                  alt: "logo_url"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlInputButton", {
                                attrs: { type: "plain", label: "Remove logo" },
                                on: { clicked: _vm.onRemoveLogo }
                              })
                            ],
                            1
                          )
                    ]),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-900",
                      attrs: { text: "Center name" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid grid-cols-2 col-span-8" },
                      [
                        _c("BlInputText", {
                          attrs: { input: _vm.nameInput },
                          on: { changed: _vm.inputHandler }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-900",
                      attrs: { text: "Currency for Credits in Appointments" }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid grid-cols-2 col-span-8" }, [
                      _c(
                        "div",
                        { staticClass: "relative" },
                        [
                          _c("BlSelectBox", {
                            attrs: {
                              search: "",
                              placeholder: "Select currency",
                              options: _vm.currencyOptions,
                              disabled: _vm.currentCenter.currency_confirmed
                            },
                            on: {
                              change: function($event) {
                                return _vm.onChangeCurrency($event)
                              }
                            },
                            model: {
                              value: _vm.currencyInput,
                              callback: function($$v) {
                                _vm.currencyInput = $$v
                              },
                              expression: "currencyInput"
                            }
                          }),
                          _vm._v(" "),
                          _vm.currentCenter.currency_confirmed
                            ? _c(
                                "BlTooltip",
                                {
                                  staticClass:
                                    "absolute top-0 right-0 z-10 grid w-10 h-10 place-items-center",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "tooltip",
                                        fn: function() {
                                          return [
                                            _c("div", { staticClass: "w-40" }, [
                                              _vm._v(
                                                "\n                  To change the currency, please contact the Blüm support\n                  team.\n                "
                                              )
                                            ])
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    3089436949
                                  )
                                },
                                [
                                  _vm._v(" "),
                                  _c("BlIcon", {
                                    staticClass: "w-6 h-6",
                                    attrs: { icon: "info" }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.confirmCurrencyOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Confirm currency change",
                label: "Confirm",
                submitLoading: _vm.submitLoading
              },
              on: {
                "backdrop-close": _vm.onCancelChangeCurrency,
                "backdrop-action": function($event) {
                  return _vm.onChangeCurrency(_vm.currencyInput)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "px-8", style: { width: "40rem" } },
                [
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text: "You are about to set the credit currency to"
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: {
                          text: _vm.currencyName[_vm.currencyInput] + "."
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "Please note, this change can only be made once and cannot be reversed."
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "Do you want to proceed?" }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.changeBranchOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Turn off branches setting",
              description:
                "Do you want to turn off the Branches setting? All branch tags will be removed from the center and clients. Reactivating the setting will restore all previous branch data.",
              label: "Confirm",
              submitLoading: _vm.submitLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.changeBranchOpened = false
              },
              "backdrop-action": _vm.onChangeBranch
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ee16c5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ee16c5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/GeneralInformation.vue
// module id = null
// module chunks = 